import React, { useEffect } from 'react'
import { ThemeProvider } from '@/shared/components/ThemeProvider'
import { AbilityProvider } from '@/shared/lib/authorization'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { BsProvider } from '@workspace/ui/components/Provider'
import { clearProactiveRefresh, initializeTokenService } from '@/shared/lib/tokenService'
import { authStore } from '@/shared/store/auth.store'
import { useSelector } from '@xstate/store/react'

export const Providers = ({ children }: { children: React.ReactNode }) => {
    const isAuthenticated = useSelector(authStore, state => state.context.isAuthenticated)

    // Initialize token service on mount if user is authenticated
    useEffect(() => {
        if (isAuthenticated) {
            initializeTokenService()
        }

        // Cleanup on unmount
        return () => {
            clearProactiveRefresh()
        }
    }, [])

    return (
        <BsProvider locale="vi-VN">
            <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
                <AbilityProvider>
                    {children}
                    <ReactQueryDevtools initialIsOpen={false} />
                </AbilityProvider>
            </ThemeProvider>
        </BsProvider>
    )
}
